export function IsUrlValid(str) {
  if (!str) return false;
  var res = str.match(/^(http:\/\/www\.|http:\/\/|https:\/\/www\.|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm);
  if (res == null)
    return false;
  else
    return true;
}
